export enum EmployerFundLedgerType {
  TOP_UP = "TOP_UP",
  TRANSACTION = "TRANSACTION",
  LOAD_FEE = "LOAD_FEE",
  ISSUE_CARD_FEE = "ISSUE_CARD_FEE",
  RE_ISSUE_CARD_FEE = "RE_ISSUE_CARD_FEE",
  MONTHLY_USER_FEE = "MONTHLY_USER_FEE"
}
